module.exports = __webpack_public_path__ + "static/img/6.ecb50e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/6.png
// module id = 7BJ4
// module chunks = 0